/**
 * Datos predefinidos del filtro.
 * 
 * @returns Object
 * @author Fernando Claros
 */
export const dataInitialFilter = () => {
  return {
    param: '',
    page: 1,
    per_page: 10,
    total: 0
  };
};

/**
 * Datos predefinidos de una variable configurable.
 * 
 * @returns Object
 * @author Fernando Claros
 */
export const dataInitialConfigurableVariable = () => {
  return {
    id: null,
    phone: "",
    phone_code: "",
    is_active: 0,
    slq_company_id: null,
    slq_country_id: null,
    sys_list_id: null,
    company: {
      id: null,
      nombre: ""
    },
    country: {
      id: null,
      code: "",
      name: ""
    },
    languague: {
      id: null,
      lista: ""
    }
  };
};

export default {
  modalForm: {
    isOpen: false,
    action: 'CREATE'
  },
  filter: dataInitialFilter(),
  configurableVariable: dataInitialConfigurableVariable(),
  configurableVariables: [],
  model: ''
};
